interface JoinIntent {
  token: string;
  timestamp: number;
}

interface RegistrationIntent {
  inviteToken: string;
  timestamp: number;
}

class SessionService {
  private static readonly JOIN_INTENT_KEY = 'league_join_intent';
  private static readonly REGISTRATION_INTENT_KEY = 'registration_intent';
  private static readonly INTENT_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

  storeJoinIntent(token: string): void {
    const intent: JoinIntent = {
      token,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(SessionService.JOIN_INTENT_KEY, JSON.stringify(intent));
  }

  getJoinIntent(): string | null {
    const stored = sessionStorage.getItem(SessionService.JOIN_INTENT_KEY);
    if (!stored) return null;

    try {
      const intent: JoinIntent = JSON.parse(stored);
      const age = Date.now() - intent.timestamp;

      if (age > SessionService.INTENT_EXPIRY_MS) {
        this.clearJoinIntent();
        return null;
      }

      return intent.token;
    } catch {
      // Invalid JSON, clear it
      this.clearJoinIntent();
      return null;
    }
  }

  clearJoinIntent(): void {
    sessionStorage.removeItem(SessionService.JOIN_INTENT_KEY);
  }

  storeRegistrationIntent(inviteToken: string): void {
    const intent: RegistrationIntent = {
      inviteToken,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(SessionService.REGISTRATION_INTENT_KEY, JSON.stringify(intent));
  }

  getRegistrationIntent(): string | null {
    const stored = sessionStorage.getItem(SessionService.REGISTRATION_INTENT_KEY);
    if (!stored) return null;

    try {
      const intent: RegistrationIntent = JSON.parse(stored);
      const age = Date.now() - intent.timestamp;

      if (age > SessionService.INTENT_EXPIRY_MS) {
        this.clearRegistrationIntent();
        return null;
      }

      return intent.inviteToken;
    } catch {
      // Invalid JSON, clear it
      this.clearRegistrationIntent();
      return null;
    }
  }

  clearRegistrationIntent(): void {
    sessionStorage.removeItem(SessionService.REGISTRATION_INTENT_KEY);
  }
}

export const sessionService = new SessionService();
